import React, { useState, useEffect } from 'react';
import { getBuyerPageData } from '../services/buyerService';
import { getStrapiMedia, renderSafeText } from '../lib/strapi';


const Buyers = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getBuyerPageData();
      setData(result);
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading || !data) {
    return (
      <div className="py-40 text-center flex flex-col items-center justify-center space-y-4">
        <div className="w-12 h-12 border-4 border-widya-green border-t-transparent rounded-full animate-spin"></div>
        <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">Loading Buyer Portal...</p>
      </div>
    );
  }

  const heroImageUrl = getStrapiMedia(data.hero_image);

  // Prepare Harvest Flow Images
  const hfLogos = data.harvest_flow_logo || [];
  const hfImg1 = hfLogos.find(i => i.name?.includes('Imag1') || i.name?.includes('Img1')) || hfLogos[0];
  const hfImg2 = hfLogos.find(i => i.name?.includes('Img2')) || hfLogos[1];

  const renderHarvestFlowDescription = (description) => {
    if (!Array.isArray(description)) return null;
    
    return (
      <div className="space-y-6">
        {description.map((block, i) => {
          if (block.type === 'list' && block.children) {
            return (
              <ul key={i} className="space-y-6">
                {block.children.map((li, j) => {
                  if (li.type !== 'list-item') return null;
                  return (
                    <li key={j} className="flex items-start">
                      <span className="mr-3 mt-1 text-black text-xl leading-none">•</span>
                      <p className="text-[#333333] text-[16px] md:text-[17px] font-normal leading-relaxed tracking-[-0.3px]">
                        {li.children.map((child, k) => (
                          child.bold ? <strong key={k} className="font-bold text-black">{child.text}</strong> : <React.Fragment key={k}>{child.text}</React.Fragment>
                        ))}
                      </p>
                    </li>
                  );
                })}
              </ul>
            );
          } else if (block.type === 'paragraph' && block.children) {
            const textContent = block.children.map(c => c.text).join('');
            if (!textContent.trim()) return null; // Skip empty paragraphs
            return (
              <p key={i} className="text-[#333333] text-[16px] md:text-[17px] font-normal leading-relaxed tracking-[-0.3px] mt-6">
                {block.children.map((child, k) => (
                  child.bold ? <strong key={k} className="font-bold text-black">{child.text}</strong> : <React.Fragment key={k}>{child.text}</React.Fragment>
                ))}
              </p>
            );
          }
          return null;
        })}
      </div>
    );
  };

  return (
    <div className="bg-white">
      <section className="relative overflow-hidden min-h-[60vh] lg:min-h-[85vh] flex items-center justify-center">
        {heroImageUrl ? (
          <>
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${heroImageUrl})` }}
            />
            <div className="absolute inset-0 bg-black/40" />
          </>
        ) : (
          <div className="absolute inset-0 bg-widya-footer" />
        )}

        <div className="container mx-auto px-6 text-center relative z-10 w-full max-w-[1200px]">
          <h1 className="text-[46px] md:text-[64px] lg:text-[80px] font-bold tracking-tight leading-[1.1] max-w-5xl mx-auto font-heading text-white drop-shadow-lg">
            {renderSafeText(data.hero_title)}
          </h1>
          {data.hero_subtitle && (
            <p className="text-xl text-white/90 max-w-2xl mx-auto font-light leading-relaxed mt-6">
              {renderSafeText(data.hero_subtitle)}
            </p>
          )}
        </div>
      </section>

      <section className="py-24 px-6 bg-white">
        <div className="container mx-auto max-w-[1200px]">
          
          {data.description_heading && (
            <div className="mb-12 text-center">
              <p className="text-[20px] md:text-[24px] text-gray-600 font-medium max-w-4xl mx-auto tracking-[-0.5px]">
                {renderSafeText(data.description_heading)}
              </p>
            </div>
          )}

          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
            <div className="lg:w-[45%]">
              <h2 className="font-bold leading-tight tracking-[-1px] text-black font-heading mb-8">
                <span className="block text-[36px] md:text-[42px] leading-[1.1]">WIDYA HarvestFlow</span>
                <span className="block mt-2 text-[24px] md:text-[28px]">Platform Overview</span>
              </h2>
              {renderHarvestFlowDescription(data.harvest_flow_description)}
            </div>
            
            <div className="lg:w-[55%] flex flex-col gap-6">
              {hfImg1 && (
                <div className="w-full h-auto">
                  <img src={getStrapiMedia(hfImg1)} alt="Status Quo vs With WIDYA" className="w-full h-auto object-contain" />
                </div>
              )}
              {hfImg2 && (
                <div className="flex justify-center mt-2">
                  <img src={getStrapiMedia(hfImg2)} alt="Ecosystem Matrix" className="w-full max-w-[480px] h-auto object-contain" />
                </div>
              )}
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Buyers;